import React from 'react';
import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { usePriceService } from '../../utils/hooks/priceService';
import { Typography } from '../Typography';
import { SecondaryToolbar } from '../SecondaryToolbar';
import { useDateTimeService } from '../../utils/hooks/dateTimeService';
import { useUser } from '../../utils/hooks/auth';


interface DebtBannerProps {
    dueDate: Date;
    debt: number;
}

const DebtBanner = ({ dueDate, debt }: DebtBannerProps) => {
    const { dateTimeService } = useDateTimeService();
    const { user } = useUser();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

    const { priceService } = usePriceService();
    const { t } = useTranslation();
    const debtTranslated = priceService.toLocaleString(debt);
    const localizedDueDate = dateTimeService.localizeDate(dueDate, user.cultureCode);

    return (
        <>
            <SecondaryToolbar style={{ background: theme.palette.error.main }}>
                <Box alignItems='center' justifyContent="center" display='flex' width="100%">
                    <Typography fontWeight="semiBold" variant={isDesktop ? 'body1' : 'body2'}>
                        {t('Unfortunately, you will lose access to the application on {{localizedDueDate}}. Please pay the overdue invoices in the amount {{debtTranslated}}.',
                             { debtTranslated, localizedDueDate },
                             )}
                    </Typography>
                </Box>
            </SecondaryToolbar>
        </>
    );
};

export default DebtBanner;
